export function buildEmbeddableUrl(rawUrl) {
  if (!rawUrl) return '';
  const url = rawUrl.trim();
  const youtubeRegex =
    /^(?:https?:\/\/)?(?:m\.|www\.|youtube-nocookie\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:.*)?$/;
  const vimeoRegex =
    /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
  const vimeoEventRegex =
    /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:event\/(?:\w+\/)?|event\/([^\/]*)\/event\/|event\/(\d+)\/event\/|event\/|)(\d+)(?:$|\/|\?)/;

  const youtubeMatch = url.match(youtubeRegex);
  if (youtubeMatch && youtubeMatch[1]?.length === 11) {
    const paramsString = (() => {
      try {
        const parsed = new URL(url);
        return parsed.search;
      } catch (error) {
        const idx = url.indexOf('?');
        return idx >= 0 ? url.substring(idx) : '';
      }
    })();

    const params = new URLSearchParams(paramsString);
    if (!params.has('autoplay')) {
      params.set('autoplay', '0');
    }
    if (!params.has('rel')) {
      params.set('rel', '0');
    }
    const paramString = params.toString();
    return `https://www.youtube-nocookie.com/embed/${youtubeMatch[1]}${
      paramString ? `?${paramString}` : ''
    }`;
  }

  const vimeoMatch = url.match(vimeoRegex);
  if (vimeoMatch && vimeoMatch[3]) {
    return `https://player.vimeo.com/video/${vimeoMatch[3]}?autoplay=0`;
  }

  const vimeoEventMatch = url.match(vimeoEventRegex);
  if (vimeoEventMatch && vimeoEventMatch[3]) {
    return `https://vimeo.com/event/${vimeoEventMatch[3]}/embed?autoplay=0`;
  }

  return url;
}
